import { Collection } from "shared/Collection.js";
import { CategoryModel } from "shared/models/CategoryModel.js";

export class CategoryCollection extends Collection {
  get Model() {
    return CategoryModel;
  }
}
